import { api } from '../../lib/api.ts';

export type RequestStatus = 'DRAFT' | 'SENT' | 'CLOSED';
export type RequestMode = 'AUTOMATIC' | 'MANUAL';

export interface RequestItem {
  id: string;
  name: string;
  qty: number;
  unit: string;
  spec: string | null;
}

export interface Request {
  id: string;
  refNumber: string;
  title: string;
  status: RequestStatus;
  mode: RequestMode;
  deadline: string | null;
  items: RequestItem[];
  createdAt: string;
}

export interface RequestListResult {
  requests: Request[];
  total: number;
  page: number;
  pageSize: number;
}

export interface RequestItemInput {
  name: string;
  qty: number;
  unit: string;
  spec?: string;
}

export interface RequestCreateInput {
  title: string;
  deadline?: string;
  items: RequestItemInput[];
}

export const requestsApi = {
  list: (params: { status?: RequestStatus; page?: number; pageSize?: number } = {}) =>
    api.get<RequestListResult>('/requests', { params }).then((r) => r.data),
  create: (input: RequestCreateInput) =>
    api.post<{ request: Request }>('/requests', input).then((r) => r.data.request),
  get: (id: string) =>
    api.get<{ request: Request }>(`/requests/${id}`).then((r) => r.data.request),
  setMode: (id: string, mode: RequestMode) =>
    api.patch<{ request: Request }>(`/requests/${id}/mode`, { mode }).then((r) => r.data.request),
  // Optional specification document (single, downloadable by vendors).
  getSpecDoc: (id: string) =>
    api.get<{ specDoc: SpecDoc | null }>(`/requests/${id}/spec-doc`).then((r) => r.data.specDoc),
  uploadSpecDoc: (id: string, body: { fileName: string; mime: string; dataBase64: string }) =>
    api.put<{ specDoc: SpecDoc }>(`/requests/${id}/spec-doc`, body).then((r) => r.data.specDoc),
  deleteSpecDoc: (id: string) =>
    api.delete(`/requests/${id}/spec-doc`).then(() => undefined),
  specDocFileUrl: (id: string) => `/requests/${id}/spec-doc/file`,
};

export interface SpecDoc {
  fileName: string;
  mime: string;
  size: number;
  uploadedAt: string;
}
